// extracted by mini-css-extract-plugin
module.exports = {"header":"header__9kNYi","title":"title__3YlOv"};